import { Controller } from 'stimulus';

class SponsorRowDisclaimerModalController extends Controller {
  static targets = [
    'modal',
    'background',
    'close',
    'text'
  ]

  connect() {
    EventManager.on('sponsor-row-show-disclaimer', (data) => {
      this.updateModal(data);
      this.openModal();
    })
  }

  closeModal = e => {
    if (e) {
      if(e.target !== this.backgroundTarget && e.target !== this.closeTarget && e.target.parentElement !== this.closeTarget ) return;

      e.preventDefault();
      e.stopImmediatePropagation();
    }
    const body = document.querySelector('body')
    this.modalTarget.classList.remove('active')
  }

  updateModal = data => {
    this.textTarget.innerHTML =data.disclaimerText;
  }

  openModal = e => {
    if (e) {
      e.preventDefault();
    }

    const body = document.querySelector('body')
    this.modalTarget.classList.add('active')
  }
}

export default SponsorRowDisclaimerModalController;
